var map = {
	"./allgreen.png": 60310,
	"./angrybull.png": 55786,
	"./appreciated.png": 69292,
	"./bloodbath.png": 13793,
	"./crapmine.png": 76101,
	"./crashingdown.png": 89071,
	"./cryptomarket.png": 12307,
	"./deadweight.png": 56418,
	"./diamondhand.png": 9769,
	"./downchart.png": 22162,
	"./feelingsick.png": 52832,
	"./goldmine.png": 10555,
	"./heart.png": 67362,
	"./kingofthemarket.png": 83141,
	"./kiss.png": 98846,
	"./like.png": 37921,
	"./queenofthemarket.png": 60874,
	"./sadbull.png": 46161,
	"./shock.png": 7408,
	"./shocked.png": 53771,
	"./smirkingbull.png": 53179,
	"./tothemood.png": 34571,
	"./upchart.png": 93731
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 57407;